module.exports = __webpack_public_path__ + "static/media/shops.26c5baea.svg";